import SearchBar from '../../navbar/components/SearchBar';

const TAGMeContent = ({
  children,
  activeTab,
  onTabChange,
  onCollaborationClick,
  onMilestoneClick,
}) => {
  const tabs = ['Collaborations', 'Milestones', 'Jobs'];

  return (
    <div className='w-full px-4 sm:px-6 lg:px-8 py-16'>
      {/* Section Header */}
      <div className='flex flex-col mb-8' data-tagme-section>
        {/* Search Bar and Tab Button Group - Aligned with content below */}
        <div className='flex items-center justify-between'>
          {/* Search Bar - Left aligned with Filters */}
          <div className='w-7/12'>
            <SearchBar
              onInputChange={e => console.log('Search:', e.target.value)}
              placeholder='Search for Collaborations or Artists'
              className='w-full'
            />
          </div>

          {/* Segmented Tab Button Group - Extended width to align with Works grid */}
          <div className='flex-1 flex justify-end'>
            <div className='inline-flex rounded-md border border-white/30 bg-white/10 backdrop-blur-md p-1 shadow-lg shadow-black/10'>
              {tabs.map((tab, index) => (
                <button
                  key={tab}
                  onClick={() => onTabChange(tab)}
                  className={`relative px-4 sm:px-10 lg:px-16 py-3 text-sm sm:text-base font-semibold tracking-wide transition-all duration-300 ease-in-out group ${
                    activeTab === tab
                      ? 'text-white'
                      : 'text-black group-hover:text-white'
                  }`}
                >
                  {/* Active Background - 点击后黑色 */}
                  {activeTab === tab && (
                    <div className='absolute inset-0 bg-black rounded-sm transition-all duration-300 ease-in-out' />
                  )}

                  {/* Hover Background - 鼠标悬停紫色 */}
                  {activeTab !== tab && (
                    <div className='absolute inset-0 bg-transparent group-hover:bg-purple-500 rounded-sm transition-all duration-300 ease-in-out' />
                  )}

                  {/* Text Content */}
                  <span className='relative z-10'>{tab}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className='flex flex-col lg:flex-row gap-8'>{children}</div>
    </div>
  );
};

export default TAGMeContent;
